/* GRH wholesale page: calculator, hero card and mobile timeline carousel.
   All prices come from data attributes the Liquid writes from Shopify (variant price + wholesale_line metaobject).
   Customizer-safe: custom element with an idempotent connectedCallback, plus shopify:section:load handling. */
(function () {
  if (window.__gwWholesale) return;
  window.__gwWholesale = true;

  function fmt(n, cents) {
    var v = Number(n) || 0;
    return '$' + v.toLocaleString('en-US', { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: cents ? 2 : 0 });
  }
  function plural(u, q) { return q === 1 ? u : u + 's'; }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? (d || 0) : n; }

  var Calc = function () { return Reflect.construct(HTMLElement, [], Calc); };
  Calc.prototype = Object.create(HTMLElement.prototype);
  Calc.prototype.constructor = Calc;
  Object.setPrototypeOf(Calc, HTMLElement);

  Calc.prototype.connectedCallback = function () {
    if (this.__gwInited) return;
    this.__gwInited = true;
    this.dataset.inited = '1';
    var root = this;
    var rows = [].slice.call(root.querySelectorAll('[data-gw-row]'));
    if (!rows.length) return;

    var sampleTier = Math.min(4, Math.max(1, parseInt(root.dataset.sampleTier || '3', 10))) - 1;
    var tierMin = [0, num(root.dataset.t2Min, 5000), num(root.dataset.t3Min, 10000)];
    var maxCase = parseInt(root.dataset.maxCase || '40', 10), maxUnit = parseInt(root.dataset.maxUnit || '250', 10);
    var maxCaseDrop = parseInt(root.dataset.maxCaseDrop || '600', 10), maxUnitDrop = parseInt(root.dataset.maxUnitDrop || '300', 10);
    var mode = 'stock';

    var P = rows.map(function (el) {
      var d = el.dataset;
      return { el: el, id: d.id, title: d.title, group: d.group, upc: parseInt(d.upc || '1', 10) || 1,
        caseLabel: d.caseLabel, unitLabel: d.unitLabel, unitMsrp: num(d.msrp),
        tiers: [num(d.t1), num(d.t2), num(d.t3), num(d.t4)], sample: parseInt(d.sample || '0', 10), sampleM: parseInt(d.sampleM || '0', 10), sort: parseInt(d.sort || '0', 10), q: 0 };
    });
    P.sort(function (a, b) { return a.sort - b.sort; });

    /* group headers + reorder DOM to sorted order */
    var list = root.querySelector('[data-gw-rows]');
    if (list) {
      list.innerHTML = '';
      var g = '';
      P.forEach(function (p) {
        if (p.group !== g) { g = p.group; var h = document.createElement('div'); h.className = 'gw-group'; h.textContent = g; list.appendChild(h); }
        list.appendChild(p.el);
      });
    }

    function unitPrice(p, t) { return mode === 'drop' && p.upc > 1 ? p.tiers[t] / p.upc : p.tiers[t]; }
    function unitMsrp(p) { return mode === 'drop' && p.upc > 1 ? p.unitMsrp : p.unitMsrp * p.upc; }
    function shortUnit(p) { return mode === 'drop' && p.upc > 1 ? p.unitLabel : (p.upc > 1 ? 'case' : p.unitLabel); }
    function sliderMax(p, q) { var base = mode === 'drop' ? (p.upc > 1 ? maxCaseDrop : maxUnitDrop) : (p.upc > 1 ? maxCase : maxUnit); return Math.max(base, Math.ceil((q || 0) / 10) * 10); }
    function label(p) { return (mode === 'drop' && p.upc > 1 ? p.unitLabel : p.caseLabel) + ' · MSRP ' + fmt(unitMsrp(p), true) + ' · Tier ' + (sampleTier + 1) + ' ' + fmt(unitPrice(p, sampleTier), true) + ' · you keep <b>' + fmt(unitMsrp(p) - unitPrice(p, sampleTier), true) + '</b> each'; }

    function build(p) {
      var el = p.el, mx = sliderMax(p, p.q);
      el.querySelector('[data-gw-sub]').innerHTML = label(p);
      var r = el.querySelector('input[type=range]'), n = el.querySelector('input[type=number]');
      r.max = mx; r.value = p.q; r.style.setProperty('--pct', (mx ? p.q / mx * 100 : 0) + '%');
      r.setAttribute('aria-valuetext', p.q + ' ' + plural(shortUnit(p), p.q));
      el.querySelector('[data-gw-max]').textContent = mx;
      n.value = p.q;
      el.querySelector('[data-gw-unit]').textContent = plural(shortUnit(p), p.q) + (mode === 'drop' ? ' / mo' : '');
    }

    function setQty(p, v, from) {
      v = Math.max(0, parseInt(v, 10) || 0); p.q = v;
      var el = p.el, r = el.querySelector('input[type=range]'), n = el.querySelector('input[type=number]'), mx = sliderMax(p, v);
      if (parseInt(r.max, 10) !== mx) { r.max = mx; el.querySelector('[data-gw-max]').textContent = mx; }
      if (from !== 'range') r.value = v;
      if (from !== 'number') n.value = v;
      r.style.setProperty('--pct', (mx ? v / mx * 100 : 0) + '%');
      r.setAttribute('aria-valuetext', v + ' ' + plural(shortUnit(p), v));
      el.querySelector('[data-gw-unit]').textContent = plural(shortUnit(p), v) + (mode === 'drop' ? ' / mo' : '');
      calc();
    }

    var out = function (k) { return root.querySelector('[data-gw-out="' + k + '"]'); };
    var T = root.dataset;
    function calc() {
      var t1 = 0, retail = 0, units = 0, cost = 0;
      P.forEach(function (p) { if (!p.q) return; t1 += p.q * unitPrice(p, 0); retail += p.q * unitMsrp(p); units += p.q * (mode === 'drop' ? 1 : p.upc); cost += p.q * unitPrice(p, sampleTier); });
      var qual = t1 >= tierMin[2] ? 2 : t1 >= tierMin[1] ? 1 : 0;
      var profit = retail - cost, margin = retail ? Math.round(profit / retail * 100) : 0, isDrop = mode === 'drop';
      out('tier').textContent = 'Tier ' + (sampleTier + 1) + ' sample pricing';
      out('profit').textContent = isDrop ? fmt(profit) + '/mo' : fmt(profit);
      out('profitLbl').textContent = isDrop ? T.lblProfitDrop : T.lblProfitStock;
      out('costLbl').textContent = isDrop ? T.lblCostDrop : T.lblCostStock;
      out('retailLbl').textContent = isDrop ? T.lblRetailDrop : T.lblRetailStock;
      out('cost').textContent = fmt(cost, true);
      out('retail').textContent = fmt(retail, true);
      out('margin').textContent = margin + '%';
      out('extraLbl').textContent = isDrop ? T.lblExtraDrop : T.lblExtraStock;
      out('extra').textContent = isDrop ? fmt(profit * 12) : units.toLocaleString('en-US');
      var n = out('nudge');
      if (!retail) n.innerHTML = isDrop ? T.msgEmptyDrop : T.msgEmptyStock;
      else if (isDrop) n.innerHTML = T.msgDrop;
      else if (qual === 2) n.innerHTML = T.msgQualifies;
      else n.innerHTML = T.msgShort.replace('{tier}', '<b>Tier ' + (qual + 1) + '</b>').replace('{gap}', '<b>' + fmt(tierMin[2] - t1) + '</b>');
      out('fine').textContent = isDrop ? T.fineDrop : T.fineStock;
      var apply = out('apply'); if (apply) apply.textContent = retail ? (isDrop ? T.btnApplyDrop : T.btnApplyStock) : T.btnApplyEmpty;
      var mp = out('miniProfit'), ms = out('miniSub');
      if (mp) mp.textContent = (isDrop ? fmt(profit) + '/mo' : fmt(profit)) + ' profit';
      if (ms) ms.textContent = 'Tier ' + (sampleTier + 1) + ' sample · ' + (isDrop ? 'monthly cost ' : 'cost ') + fmt(cost, true) + ' · sells for ' + fmt(retail, true);
    }

    function summary() {
      var lines = [], c = 0;
      P.forEach(function (p) { if (!p.q) return; lines.push(p.q + ' x ' + p.title + (mode === 'drop' && p.upc > 1 ? ' (' + p.unitLabel + 's)' : '')); c += p.q * unitPrice(p, sampleTier); });
      if (!lines.length) return '';
      return (mode === 'drop' ? 'Dropship estimate, per month: ' : 'Order from the calculator: ') + lines.join(', ') + '. At Tier ' + (sampleTier + 1) + ' sample pricing: ' + fmt(c, true) + '.';
    }

    function loadSample() { P.forEach(function (p) { p.q = mode === 'drop' ? p.sampleM : p.sample; build(p); }); calc(); }

    root.addEventListener('input', function (e) {
      var i = e.target; if (i.tagName !== 'INPUT') return;
      var id = i.getAttribute('data-id'), p = P.filter(function (x) { return x.id === id; })[0]; if (!p) return;
      setQty(p, i.value, i.type === 'range' ? 'range' : 'number');
    });
    root.addEventListener('click', function (e) {
      var m = e.target.closest('[data-gw-mode]');
      if (m) {
        mode = m.getAttribute('data-gw-mode');
        root.querySelectorAll('[data-gw-mode]').forEach(function (x) { x.classList.toggle('is-on', x === m); });
        root.querySelector('[data-gw-help]').textContent = mode === 'drop' ? T.helpDrop : T.helpStock;
        loadSample(); return;
      }
      var pr = e.target.closest('[data-gw-preset]');
      if (pr) {
        var k = pr.getAttribute('data-gw-preset');
        if (k === 'sample') loadSample();
        else if (k === 'double') { P.forEach(function (p) { p.q = p.q * 2; build(p); }); calc(); }
        else { P.forEach(function (p) { p.q = 0; build(p); }); calc(); }
        return;
      }
      var ap = e.target.closest('[data-gw-out="apply"]');
      if (ap) {
        var s = summary();
        showSummary(s);
        try { sessionStorage.setItem('gw_summary', s); } catch (err) {}
      }
    });

    root.querySelector('[data-gw-help]').textContent = T.helpStock;
    loadSample();
    root.classList.add('is-ready');
    var sec = root.closest('.gw-calc'); if (sec) sec.classList.add('is-ready');

    /* hero card: "$X in. $Y out." from the stock sample */
    var hin = document.querySelector('[data-gw-hero-in]'), hout = document.querySelector('[data-gw-hero-out]');
    if (hin && hout) {
      var c = 0, r = 0;
      P.forEach(function (p) { c += p.sample * p.tiers[sampleTier]; r += p.sample * p.unitMsrp * p.upc; });
      if (c && r) { hin.textContent = fmt(c); hout.textContent = fmt(r); }
    }
  };
  if (!customElements.get('grh-wholesale-calc')) customElements.define('grh-wholesale-calc', Calc);

  /* apply section: put the calculator summary in the native message box, or on the order card above an app form */
  function showSummary(s) {
    if (!s) return;
    var f = document.querySelector('[data-gw-message]');
    if (f && f.value.indexOf('calculator') === -1) f.value = (f.value ? f.value + '\n\n' : '') + s;
    var card = document.querySelector('[data-gw-summary]');
    if (card) {
      var t = card.querySelector('[data-gw-summary-text]'), m = card.querySelector('[data-gw-summary-mail]');
      if (t) t.textContent = s;
      if (m) m.setAttribute('href', 'mailto:' + (m.getAttribute('data-email') || '') + '?subject=' + encodeURIComponent(m.getAttribute('data-subject') || 'GRH wholesale account') + '&body=' + encodeURIComponent(s + '\n\n'));
      card.removeAttribute('hidden');
    }
  }
  document.addEventListener('DOMContentLoaded', function () {
    var saved = '';
    try { saved = sessionStorage.getItem('gw_summary') || ''; } catch (err) {}
    if (saved && document.querySelector('[data-gw-summary]')) showSummary(saved);
  });

  /* form: honeypot guard */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.matches('#gw-apply-form')) return;
    var hp = f.querySelector('[data-gw-hp]'); if (hp && hp.value) { e.preventDefault(); }
  });
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.gw-sticky')) document.body.classList.add('gw-has-sticky');
    /* hide the sticky apply bar while the apply section is on screen */
    var ap = document.getElementById('gw-apply');
    if (ap && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (en) { document.body.classList.toggle('gw-apply-inview', en.isIntersecting); });
      }, { threshold: 0.05 }).observe(ap);
    }
  });

  /* timeline: swipe carousel on phones, auto-advances every second, pauses on touch */
  function initTimeline(sec) {
    var tl = sec.querySelector('[data-gw-timeline]'), dots = sec.querySelector('[data-gw-dots]');
    if (!tl || !dots || tl.dataset.inited === '1') return;
    tl.dataset.inited = '1';
    var cards = [].slice.call(tl.children), mq = window.matchMedia('(max-width:960px)'), rm = window.matchMedia('(prefers-reduced-motion: reduce)');
    var idx = 0, timer = null, hold = 0, busy = 0, every = parseInt(tl.dataset.every || '1000', 10);
    dots.innerHTML = '';
    cards.forEach(function (_, i) { var d = document.createElement('span'); if (i === 0) d.className = 'is-on'; dots.appendChild(d); });
    function mark() { [].forEach.call(dots.children, function (d, k) { d.className = k === idx ? 'is-on' : ''; }); }
    function go(i) { idx = (i + cards.length) % cards.length; var c = cards[idx]; busy = Date.now() + 700; tl.scrollTo({ left: Math.max(0, c.offsetLeft - (tl.clientWidth - c.offsetWidth) / 2), behavior: 'smooth' }); mark(); }
    function tick() { if (Date.now() < hold) return; go(idx + 1); }
    function start() { stop(); if (mq.matches && !rm.matches) timer = setInterval(tick, every); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    ['touchstart', 'pointerdown'].forEach(function (ev) { tl.addEventListener(ev, function () { hold = Date.now() + 4000; }, { passive: true }); });
    tl.addEventListener('scroll', function () {
      if (!mq.matches || Date.now() < busy) return;
      var mid = tl.scrollLeft + tl.clientWidth / 2, best = 0, bd = 1e9;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = i; } });
      if (best !== idx) { idx = best; mark(); }
    }, { passive: true });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { if (e.isIntersecting) start(); else stop(); }); }, { threshold: .3 });
      io.observe(tl);
    } else { start(); }
    if (mq.addEventListener) mq.addEventListener('change', start); else if (mq.addListener) mq.addListener(start);
  }
  function scan(scope) { (scope || document).querySelectorAll('[data-gw-timeline-section]').forEach(initTimeline); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
